module.exports = __webpack_public_path__ + "img/curfox.a393be20.png";